import { render, staticRenderFns } from "./ElasticProductFilters.vue?vue&type=template&id=54316bb0"
import script from "./ElasticProductFilters.vue?vue&type=script&lang=js"
export * from "./ElasticProductFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports